import { render, staticRenderFns } from "./ReferralCodePane.vue?vue&type=template&id=902c70a8&scoped=true"
import script from "./ReferralCodePane.vue?vue&type=script&lang=ts"
export * from "./ReferralCodePane.vue?vue&type=script&lang=ts"
import style0 from "./ReferralCodePane.vue?vue&type=style&index=0&id=902c70a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902c70a8",
  null
  
)

export default component.exports